import { CallbackError, ReadCallback } from "i18next";
import { default as Backend, HttpBackendOptions } from "i18next-http-backend";

interface ILoadLocalTranslationsOptions extends HttpBackendOptions {
  backendUnavailableCallback: () => void;
}

export class FallbackLocalTranslationsLoader extends Backend {
  override options: ILoadLocalTranslationsOptions;

  constructor(services: any, options: ILoadLocalTranslationsOptions) {
    super(services, options);
    this.options = options;
  }

  override read(language: string, namespace: string, callback: ReadCallback): void {
    super.read(language, namespace, (error: CallbackError, data: any) => {
      if (error) {
        console.error(`Failed loading local fallback translations: ${language}/${namespace}`, error);
      } else {
        console.debug(`Local fallback translations loaded: ${language}/${namespace}`);
      }

      // Handle the case where local fallback translations have been loaded
      this.options.backendUnavailableCallback();

      callback(error, data);
    });
  }
}
